module.exports = __webpack_public_path__ + "img/marketing-icon-customer.de1dec60.svg";